// @flow @format
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import LoginForm from '../components/LoginForm';
import {connect} from 'react-redux';
import {PublicApi} from 'lib/cloner-api';
import {login} from '../../../reducers/session';

type State = {
	username: string,
	password: string,
	status: string,
};

type Props = {
	login: (user: string, token: string, server: string, group: number) => void,
};

class LoginFormContainer extends PureComponent<Props, State> {
	state: State;
	props: Props;

	_api: PublicApi;
	_handleChange: (e: Event) => void;
	_handleSubmit: (e: Event) => void;
	_redirect: () => void;

	static contextTypes = {
		router: PropTypes.object.isRequired,
	};

	state = {
		username: '',
		password: '',
		status: 'pristine',
	};

	constructor(props: Props) {
		super(props);

		this._api = new PublicApi();
	}

	_handleChange = (event: Event) => {
		const target = event.currentTarget;
		if (target instanceof HTMLInputElement) {
			this.setState({[target.name]: target.value, status: 'pristine'});
		}
	};

	_handleSubmit = (event: Event) => {
		event.preventDefault();

		if (this.state.loading || this.state.success) {
			return;
		}

		this.setState({status: 'loading'});

		setTimeout(() => {
			this._api.login(this.state.username, this.state.password).then(
				response => {
					if (response.resp === 2) {
						this.setState({status: 'error'});
						return;
					}

					this.setState({status: 'success'});
					this.props.login(
						response.user,
						response.token,
						response.server,
						response.group
					);

					setTimeout(
						() => this.context.router.replace('/explorer'),
						300
					);
				},
				() => this.setState({status: 'error'})
			);
		}, 900);
	};

	render() {
		return (
			<LoginForm
				{...this.state}
				handleChange={this._handleChange}
				handleSubmit={this._handleSubmit}
			/>
		);
	}
}

export default connect(null, {login})(LoginFormContainer);



// WEBPACK FOOTER //
// ./src/routes/Login/containers/LoginFormContainer.js